import React, { useRef } from 'react';
var VeltNotificationsPanelSettingsList = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-settings-list", { ref: ref }, children));
};
export default VeltNotificationsPanelSettingsList;
